module.exports = __webpack_public_path__ + "static/img/GH.af5cb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/GH.png
// module id = 5CiS
// module chunks = 34